import { useGetBlocks } from 'api/blocks/useGetBlocks';
import { ContentBannerItem } from './ContentBannerItem/index';
import { Wrap } from './style';
import { useRouter } from 'next/router';
import { useBannerPosition } from 'utils/hooks/useBannerPosition/useBannerPosition';

type ContentBannerType = {
  isMainPage?: boolean;
  count: string;
  modulId: number;
  isVerticalBanner?: boolean;
  isHorisontalBanner?: boolean;
};

export const ContentBanner = ({
  isMainPage,
  count,
  modulId,
  isVerticalBanner,
  isHorisontalBanner,
  ...props
}: ContentBannerType) => {
  const { locale } = useRouter();
  const { data: blockData } = useGetBlocks({ modulId, lang: locale });
  const { dataBanner, numberBannerFirst, numberBannerSecond } = useBannerPosition(
    blockData,
    isHorisontalBanner
  );

  const firstBanner =
    count === 'numberBannerFirst' ? numberBannerFirst : numberBannerSecond;

  return (
    <Wrap
      {...props}
      className={`${isMainPage ? 'saleForMainPage' : ''} ${
        isVerticalBanner ? 'verticalBanner' : ''
      }`}
    >
      <ContentBannerItem data={dataBanner[firstBanner]} />
    </Wrap>
  );
};

export default ContentBanner;
